// js/components/ProgressBar.js
class ProgressBar extends HTMLElement {
  static get observedAttributes() {
    return ['data-settings'];
  }

  connectedCallback() {
    this.settings = this.dataset.settings ? JSON.parse(this.dataset.settings) : {};
    new IntersectionObserver(this._onBecameVisible.bind(this)).observe(this);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-settings' && oldValue !== newValue) {
      this.settings = newValue ? JSON.parse(newValue) : {};
      this._updateProgress();
    }
  }
  
  _onBecameVisible(entries) {
    if (entries[0].isIntersecting) {
      this._updateProgress();
    }
  }

  _updateProgress() {
    // Use pre-calculated barPosition from Liquid
    const percentage = this.settings.barPosition !== undefined 
      ? Math.min(Math.max(this.settings.barPosition, 0), 100)
      : 0; // Default to 0 if no barPosition provided
    
    const progressElement = this.querySelector('[data-progress]');
    if (progressElement) {
      progressElement.style.width = `${percentage}%`;
    }
  }
}

if (!window.customElements.get("progress-bar")) window.customElements.define("progress-bar", ProgressBar);
